// Wrappers de fetch para los endpoints /api/profesor/*.
// Usan el token Bearer guardado por AuthContext (idoyoga_auth_token).
//
// Mismo patrón que adminApi.js. El backend valida rol='profesor' en cada
// request; si no, devuelve 403 ROL_INSUFICIENTE.

import { API_BASE, ApiError } from './api';

const TOKEN_KEY = 'idoyoga_auth_token';

function token() {
  try { return localStorage.getItem(TOKEN_KEY); } catch (_) { return null; }
}

async function profesorFetch(path, opts = {}) {
  const headers = {
    Authorization: `Bearer ${token() || ''}`,
    ...(opts.headers || {}),
  };
  if (opts.body && !headers['Content-Type']) headers['Content-Type'] = 'application/json';
  const r = await fetch(`${API_BASE}${path}`, { ...opts, headers });
  let body = null;
  try { body = await r.json(); } catch (_) {}
  if (!r.ok) throw new ApiError(r.status, body?.code, body?.error);
  return body;
}

export const getProfesorMe = (idioma) => {
  const q = idioma ? `?idioma=${encodeURIComponent(idioma)}` : '';
  return profesorFetch(`/api/profesor/me${q}`);
};

export const getProfesorClasesAsignadas = ({ desde, hasta, idioma } = {}) => {
  const p = new URLSearchParams();
  if (desde) p.set('desde', desde);
  if (hasta) p.set('hasta', hasta);
  if (idioma) p.set('idioma', idioma);
  const qs = p.toString();
  return profesorFetch(`/api/profesor/clases-asignadas${qs ? '?' + qs : ''}`);
};

export const getProfesorClaseAlumnos = (sesionId, idioma) => {
  const q = idioma ? `?idioma=${encodeURIComponent(idioma)}` : '';
  return profesorFetch(`/api/profesor/clase/${sesionId}/alumnos${q}`);
};

// body: { asistencias: [{reserva_id, asistio:bool}] } o { marcar_todos_vinieron: true }
export const postProfesorAsistencia = (sesionId, body, idioma) => {
  const q = idioma ? `?idioma=${encodeURIComponent(idioma)}` : '';
  return profesorFetch(`/api/profesor/clase/${sesionId}/asistencia${q}`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
};

export const getProfesorClaseNotas = (sesionId, idioma) => {
  const q = idioma ? `?idioma=${encodeURIComponent(idioma)}` : '';
  return profesorFetch(`/api/profesor/clase/${sesionId}/notas${q}`);
};

export const putProfesorClaseNotas = (sesionId, contenido, idioma) => {
  const q = idioma ? `?idioma=${encodeURIComponent(idioma)}` : '';
  return profesorFetch(`/api/profesor/clase/${sesionId}/notas${q}`, {
    method: 'PUT',
    body: JSON.stringify({ contenido }),
  });
};

// SS7.2.5 F5 — atajo "reservar como alumno"
export const getProfesorClasesDisponibles = ({ desde, hasta, idioma } = {}) => {
  const p = new URLSearchParams();
  if (desde) p.set('desde', desde);
  if (hasta) p.set('hasta', hasta);
  if (idioma) p.set('idioma', idioma);
  const qs = p.toString();
  return profesorFetch(`/api/profesor/clases-disponibles${qs ? '?' + qs : ''}`);
};
